var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cf-container" },
    [
      _c(
        "div",
        [
          _c(
            "button",
            {
              staticClass: "btn btn-success btn-sm m-r-5 m-b-15",
              attrs: { type: "button" },
              on: { click: _vm.createCallFlow }
            },
            [
              _c("i", { staticClass: "fa fa-plus" }),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "BUTTON_CREATE_CALL_FLOW",
                    expression: "'BUTTON_CREATE_CALL_FLOW'"
                  }
                ]
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "Dropdown",
            { ref: "dropdown", attrs: { tag: "div", "menu-right": true } },
            [
              _c("button", { staticClass: "btn btn-success btn-sm m-b-15" }, [
                _vm._v("\n        Create Using Template\n        "),
                _c("i", {
                  staticClass: "fa fa-angle-down",
                  attrs: { "aria-hidden": "true" }
                })
              ]),
              _vm._v(" "),
              _c(
                "template",
                { slot: "dropdown" },
                _vm._l(_vm.availableTemplates, function(template, index) {
                  return _c("li", { key: index }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: `#/dashboard/call-flow/template/${template.id}`,
                          title: template.description
                        },
                        on: {
                          click: function($event) {
                            return _vm.createCallFlowTemplate(template, $event)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(template.name) +
                            "\n          "
                        )
                      ]
                    )
                  ])
                }),
                0
              )
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "div",
            { staticClass: "grid_table_holder" },
            [
              _c(
                "v-table",
                {
                  staticClass: "table_beauty",
                  attrs: {
                    data: _vm.callFlowTrees,
                    "current-page": _vm.currentPage,
                    filters: _vm.filters,
                    "page-size": 20,
                    "hide-sort-icons": true
                  },
                  on: {
                    "update:currentPage": function($event) {
                      _vm.currentPage = $event
                    },
                    "update:current-page": function($event) {
                      _vm.currentPage = $event
                    },
                    totalPagesChanged: function($event) {
                      _vm.totalPages = $event
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "body",
                        fn: function({ displayData }) {
                          return _c(
                            "tbody",
                            {},
                            [
                              _vm._l(displayData, function(row, index) {
                                return [
                                  !(
                                    _vm.isMobile &&
                                    _vm.activeActionRowId == row.id
                                  )
                                    ? _c(
                                        "tr",
                                        {
                                          key: row.id,
                                          class: {
                                            "bg-row-odd": index % 2 === 0,
                                            "bg-row-even": index % 2 !== 0
                                          }
                                        },
                                        [
                                          _vm.isMobile
                                            ? _c("td", [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-list-function btn-expand-actions",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.displayMobileAction(
                                                          row.id
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-ellipsis-v"
                                                    })
                                                  ]
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "label",
                                                class: {
                                                  "label-default": !_vm.isEnabled(
                                                    row
                                                  ),
                                                  "label-success": _vm.isEnabled(
                                                    row
                                                  )
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      _vm.isEnabled(row)
                                                        ? _vm.$t("STATUS_LIVE")
                                                        : _vm.$t("STATUS_DRAFT")
                                                    ) +
                                                    "\n              "
                                                )
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c("span", [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.isLegacy(row)
                                                      ? _vm.$t("VERSION_LEGACY")
                                                      : _vm.$t(
                                                          "VERSION_CALL_FLOW"
                                                        )
                                                  ) +
                                                  "\n                "
                                              ),
                                              _vm.isLegacy(row)
                                                ? _c("i", {
                                                    directives: [
                                                      {
                                                        name: "tooltip",
                                                        rawName:
                                                          "v-tooltip.top.hover",
                                                        value: _vm.$t(
                                                          "VERSION_LEGACY_TOOLTIP"
                                                        ),
                                                        expression:
                                                          "$t('VERSION_LEGACY_TOOLTIP')",
                                                        modifiers: {
                                                          top: true,
                                                          hover: true
                                                        }
                                                      }
                                                    ],
                                                    staticClass:
                                                      "fa fa-question-circle m-l-5",
                                                    attrs: {
                                                      "aria-hidden": "true"
                                                    }
                                                  })
                                                : _vm._e()
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: `#/dashboard/call-flow/edit/${row.id}`
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.editCallFlow(
                                                      row.id,
                                                      $event
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(row.name) +
                                                    "\n              "
                                                )
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          !_vm.isMobile
                                            ? _c(
                                                "td",
                                                [
                                                  _c("CallFlowActions", {
                                                    attrs: {
                                                      "current-call-flow": row,
                                                      "duplicate-id":
                                                        _vm.callFlowTreeToDuplicate
                                                    },
                                                    on: {
                                                      editCallFlow:
                                                        _vm.editCallFlow,
                                                      duplicateCallFlow:
                                                        _vm.duplicateCallFlow,
                                                      "collapse-actions": function(
                                                        $event
                                                      ) {
                                                        return _vm.hideMobileAction()
                                                      },
                                                      deleteCallFlow:
                                                        _vm.confirmDeleteCallFlow
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isMobile &&
                                  _vm.activeActionRowId == row.id
                                    ? _c(
                                        "tr",
                                        {
                                          key: row.id + "-mobile",
                                          staticClass:
                                            "mobile-actions ng-animate-disabled slide-right"
                                        },
                                        [
                                          _c(
                                            "td",
                                            { attrs: { colspan: "10" } },
                                            [
                                              _c("CallFlowActions", {
                                                attrs: {
                                                  "current-call-flow": row,
                                                  "duplicate-id":
                                                    _vm.callFlowTreeToDuplicate
                                                },
                                                on: {
                                                  editCallFlow:
                                                    _vm.editCallFlow,
                                                  duplicateCallFlow:
                                                    _vm.duplicateCallFlow,
                                                  "collapse-actions": function(
                                                    $event
                                                  ) {
                                                    return _vm.hideMobileAction()
                                                  },
                                                  deleteCallFlow:
                                                    _vm.confirmDeleteCallFlow
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              })
                            ],
                            2
                          )
                        }
                      }
                    ],
                    null,
                    false,
                    456379072
                  )
                },
                [
                  _c("thead", { attrs: { slot: "head" }, slot: "head" }, [
                    _c(
                      "tr",
                      [
                        _vm.isMobile ? _c("th") : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "v-th",
                          {
                            staticClass: "col-sm-1",
                            attrs: {
                              "default-sort": "asc",
                              "sort-key": "isFinalized"
                            }
                          },
                          [_vm._v("\n            Status\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-th",
                          {
                            staticClass: "col-sm-1",
                            attrs: {
                              "default-sort": "asc",
                              "sort-key": "version"
                            }
                          },
                          [_vm._v("\n            Version\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-th",
                          {
                            staticClass: "col-sm-8",
                            attrs: { "default-sort": "asc", "sort-key": "name" }
                          },
                          [_vm._v("\n            Name\n          ")]
                        ),
                        _vm._v(" "),
                        !_vm.isMobile
                          ? _c("th", {
                              directives: [
                                {
                                  name: "t",
                                  rawName: "v-t",
                                  value: "TABLE_COL_ACTIONS",
                                  expression: "'TABLE_COL_ACTIONS'"
                                }
                              ]
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "pagination-min" }, [
                _c(
                  "div",
                  { staticClass: "text-center p-7" },
                  [
                    _c("smart-pagination", {
                      attrs: {
                        "current-page": _vm.currentPage,
                        "total-pages": _vm.totalPages,
                        "max-page-links": 7
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.currentPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.currentPage = $event
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "text-center empty-records" },
            [
              _c("Loader"),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "CALL_FLOWS_TABLE_LOADING",
                    expression: "'CALL_FLOWS_TABLE_LOADING'"
                  }
                ]
              })
            ],
            1
          ),
      _vm._v(" "),
      _vm.showConfirmation
        ? _c("CallFlowDeleteModal", {
            attrs: {
              "call-flow-tree": _vm.callFlowTreeToDelete,
              "disable-modal-confirm": _vm.disableModalConfirm,
              "deleting-call-flow-tree": _vm.deletingCallFlowTree,
              "loading-call-flow-tree-references":
                _vm.loadingCallFlowTreeReferences,
              "call-flow-tree-references": _vm.callFlowTreeReferences,
              "has-references": _vm.hasReferences,
              "call-flow-delete-force": _vm.callFlowTreeDeleteForce
            },
            on: {
              "update:callFlowDeleteForce": function($event) {
                _vm.callFlowTreeDeleteForce = $event
              },
              "update:call-flow-delete-force": function($event) {
                _vm.callFlowTreeDeleteForce = $event
              },
              closeModal: _vm.closeModal,
              attestDelete: _vm.attestDelete,
              deleteCallFlow: _vm.deleteCallFlow
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }